import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const forgotPasswordResetApi = createAsyncThunk(
  "user/forgotPasswordReset",
  async (resetData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/users/forgot-password/reset",
        resetData,
      );
      return response.data;
    } catch (error) {
      console.error("ForgotPasswordReset API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to reset password",
        );
      }
      return rejectWithValue("Failed to reset password");
    }
  },
);